var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#E9FBFB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2201_19968",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 16,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2201_19968)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 15.3L11.3335 15.6667C11.1779 15.7556 11.0112 15.7778 10.8335 15.7333C10.6557 15.6889 10.5223 15.5889 10.4335 15.4333L9.10012 13.1C9.01123 12.9444 8.98901 12.7778 9.03345 12.6C9.0779 12.4222 9.1779 12.2889 9.33345 12.2L13.1668 10H14.3335C14.4335 10 14.514 10.0306 14.5751 10.0917C14.6362 10.1528 14.6668 10.2333 14.6668 10.3333V10.6667C14.6668 11.0333 14.7973 11.3472 15.0585 11.6083C15.3196 11.8694 15.6335 12 16.0001 12C16.3668 12 16.6807 11.8694 16.9418 11.6083C17.2029 11.3472 17.3335 11.0333 17.3335 10.6667V10.3333C17.3335 10.2333 17.364 10.1528 17.4251 10.0917C17.4862 10.0306 17.5668 10 17.6668 10H18.8335L22.6668 12.2C22.8223 12.2889 22.9223 12.4222 22.9668 12.6C23.0112 12.7778 22.989 12.9444 22.9001 13.1L21.5668 15.4333C21.4779 15.5889 21.3473 15.6861 21.1751 15.725C21.0029 15.7639 20.8335 15.7389 20.6668 15.65L20.0001 15.3167V21.3333C20.0001 21.5222 19.9362 21.6806 19.8085 21.8083C19.6807 21.9361 19.5223 22 19.3335 22H12.6668C12.4779 22 12.3196 21.9361 12.1918 21.8083C12.064 21.6806 12.0001 21.5222 12.0001 21.3333V15.3ZM13.3335 13.0667V20.6667H18.6668V13.0667L20.7335 14.2L21.4335 13.0333L18.5668 11.3667C18.4001 11.9333 18.0862 12.4028 17.6251 12.775C17.164 13.1472 16.6223 13.3333 16.0001 13.3333C15.3779 13.3333 14.8362 13.1472 14.3751 12.775C13.914 12.4028 13.6001 11.9333 13.4335 11.3667L10.5668 13.0333L11.2668 14.2L13.3335 13.0667Z",
    fill: "#00A7A6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextil);
export default __webpack_public_path__ + "static/media/textil.74483c6160bc92dca481743e0134c1c8.svg";
export { ForwardRef as ReactComponent };